import 'stream-chat-react/dist/css/v2/index.css';
import { ChatWidget } from '@features/components/Chat/components/ChatWidget';
import { useChatContext } from 'stream-chat-react';
import type { ChatProps } from './types';
import { ChatConnectionGate } from './components/ChatConnectionGate';

export const Chat = ({ caseId, caseStatus, organType, donorType, inlineLayout = false, filterState }: ChatProps) => {
  const { client: chatClient } = useChatContext();

  if (!chatClient) {
    return null;
  }

  return (
    <ChatConnectionGate>
      <ChatWidget
        caseId={caseId}
        caseStatus={caseStatus}
        organType={organType}
        donorType={donorType}
        inlineLayout={inlineLayout}
        filterState={filterState}
      />
    </ChatConnectionGate>
  );
};
